import React from 'react'
import './BrandIcon.css'
import logo from '../../assets/client-logo.webp'
import { Box, Typography } from '@material-ui/core'

const BrandIcon = () => {
	return (
		<Box
		className="brandIcon"
		sx={{mr: { xs: 1, md: 3 }, my: 0.5}}
		>
			<img className="brandIcon__image"
			        src={logo}
				// srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
				alt="Logo de Almaferr"
				loading="lazy"
			/>
			<Typography
				component="span"
				className="brandIcon__word"
				sx={{
					fontFamily: "'Montserrat', 'Arial Black', Arial, sans-serif",
					fontSize: { xs: '1.15rem', sm: '1.38rem' },
					fontWeight: 900,
					letterSpacing: '0.035em',
					lineHeight: 1,
					color: '#ffffff',
				}}
			>
				Almaferr
			</Typography>
		</Box>
	)
}

export default BrandIcon
